import React from "react";
import {connect} from "react-redux";
import "../../styles/Shared/Shared.css";
import Account_Balance_Sumary from "./Account_Balance_Sumary";

const View_Expenses = (props) => {
    let balance_amount = 0;
    let income_balance = 0;
    let expense_balance = 0;
    let transaction_list = [...props.Transaction];

    transaction_list.forEach((transaction) => {
        balance_amount += Number(transaction.transaction_amount);
        if (Number(transaction.transaction_amount) > 0) {
            income_balance += Number(transaction.transaction_amount);
        } else {
            expense_balance -= Number(transaction.transaction_amount);
        }
    });

    return (
        <div>
            <Account_Balance_Sumary
                balance_amount={balance_amount}
                income_balance={income_balance}
                expense_balance={expense_balance}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        Transaction: state.Transaction
    }
};

export default connect(mapStateToProps)(View_Expenses);